import { render, staticRenderFns } from "./GoodMain.vue?vue&type=template&id=45b76ba1&scoped=true&"
import script from "./GoodMain.vue?vue&type=script&lang=js&"
export * from "./GoodMain.vue?vue&type=script&lang=js&"
import style0 from "./GoodMain.vue?vue&type=style&index=0&id=45b76ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b76ba1",
  null
  
)

export default component.exports